import { postAxios, getAxios } from '@/components/common/http'
export const loginApi = {
  // 获取扫码登录Qrcode
  qrcodeRefresh: () => {
    return getAxios('/api/v1/login/qrcode/refresh')
  },
  // 获取扫码登录Qrcode
  qrcodeLoginPolling: data => {
    return postAxios('/api/v1/login/qrcode/check', data)
  },
  // 验证登录状态
  validLogin: () => {
    return postAxios('/api/v1/login/check')
  },
  // 登出
  logout: () => {
    return postAxios('/api/v1/login/logout')
  }
}



// WEBPACK FOOTER //
// ./src/components/login/login.js